import * as CardValidator from 'card-validator';
import { Validator } from 'formstate';

export const ccNameValidator: Validator<string> = (value) => {
    if (!value) {
        return "You can't leave this field empty";
    }
    const valid = /^\s*[\u0020-\u005f]{1,26}\s*$/i.test(value);
    return valid ? null : 'Invalid characters';
};

export const ccNumberValidator: Validator<string> = (value) => {
    if (!value) {
        return "You can't leave this field empty";
    }
    return CardValidator.number(value).isValid ? null : 'Invalid card number';
};

export const ccExpValidator: Validator<string> = (value) => {
    if (!value) {
        return "You can't leave this field empty";
    }
    return /^[01]\d\/?\d\d$/.test(value) && CardValidator.expirationDate(value).isValid
        ? null
        : 'Invalid expiration date';
};

export const ccCscValidator: Validator<string> = (value) => {
    if (!value) {
        return "You can't leave this field empty";
    }
    const valid = /^\d{3,4}$/.test(value);
    return valid ? null : 'Invalid security code';
};

/**
 * Checks for a valid US or Canadian or Australian zip/postal code
 */
export const zipPostalCodeValidator: Validator<string> = (value) => {
    if (!value) {
        return "You can't leave this field empty";
    }
    const valid = /^(\d{4}|\d{5}(-\d{4})?|[a-z]\d[a-z] ?\d[a-z]\d)$/i.test(value);
    return valid ? null : 'Invalid postal code';
};
